import { Injectable } from '@angular/core';
@Injectable()
export class ModalConfig<D = any> {
    data?: D;
}
